import { Button, Form, Input } from "antd";
import * as React from "react";
import { UserService } from "../../services/user-service";
import { KNavigator, withHistory } from "../../shared/hoc/with-history";
import { KMainFunctions } from "../../shared/utilty/main-functions";

declare let window: any;

interface ILoginState {
  loginErrorMessage: string;
  isLoading: boolean;
}

interface ILoginProps {
  navigator: KNavigator;
  from: any;
}

class Login extends React.PureComponent<ILoginProps, ILoginState> {
  constructor(props) {
    super(props);
    this.state = { loginErrorMessage: "", isLoading: false };
  }

  goToSignUp = () => {
    this.props.navigator.gotoSignup();
  };

  goToForgotPassword = () => {
    this.props.navigator.gotoForgotPassword();
  };

  onSubmit = async (data: any) => {
    this.setState({ isLoading: true });
    try {
      UserService.Login(data).then(
        (res) => {
          this.setState({ loginErrorMessage: res?.data?.message });
          if (res && res.status === 200) {
            if (res?.data?.forceResetPassword === true) {
              this.props.navigator.goToResetPasswordScreen();
            } else if (this.props?.from?.pathname?.length > 0) {
              this.props.navigator.gotoUrl(this.props.from.pathname);
            } else {
              this.props.navigator.gotoStartingScreen();
            }
            this.setState({ isLoading: false });
          }
        },
        (error) => {
          if (error.response.data.message) {
            this.setState({ loginErrorMessage: error.response.data.message, isLoading: false });
          }
        }
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      this.setState({ isLoading: false });
    }
  };

  render() {
    return (
      <div className="kuika__registration">
        <div></div>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <div className="registration-left-panel">
            <div className="registration-logo" style={{ marginTop: 0 }}>
              <svg width="124" height="36" viewBox="0 0 124 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M30.3774 0C33.3932 0 35.7477 2.42188 35.7477 5.35859V30.3892C35.7477 33.3991 33.3932 35.7477 30.3774 35.7477H5.36868C2.35374 35.7477 0 33.3259 0 30.3892V5.35859C0 2.34869 2.42609 0 5.36868 0H30.3774Z"
                  fill="#246EFF"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.9639 7.28429C14.7525 6.8557 15.4941 6.63892 16.1681 6.63892C16.6668 6.63892 17.0437 6.75665 17.3135 6.86843L17.5483 6.97364L17.8244 7.1108C18.5168 7.48518 18.9872 7.99627 19.226 8.63317L19.3031 8.83029C19.3985 9.09872 19.502 9.57008 19.2301 10.2179C19.016 10.7283 18.4864 11.2904 18.06 11.7022L17.5614 12.1722L17.2898 12.4439C15.8133 13.9366 14.0938 15.7672 14.1213 17.8785C14.0964 19.7808 15.5016 21.4602 16.8631 22.8683L17.4989 23.5149L18.0604 24.046C18.4864 24.458 19.016 25.0196 19.2301 25.5299C19.502 26.1778 19.3985 26.6491 19.3031 26.9176L19.226 27.1155L19.138 27.3227C18.8483 27.9303 18.3271 28.4121 17.587 28.7568L17.3132 28.8798C17.0431 28.9912 16.6666 29.1089 16.1673 29.1089C15.4941 29.1089 14.7517 28.8921 13.9639 28.4644C10.3251 26.4892 7.6183 23.4858 6.29826 21.3346C5.56902 20.1435 5.14054 19.244 5.11417 18.1684L5.10645 17.9765L5.10752 17.7423L5.13126 17.291C5.22093 16.3386 5.63531 15.4961 6.29826 14.4141C7.6183 12.262 10.3243 9.25943 13.9639 7.28429ZM17.3618 14.2807C18.1551 13.2172 20.9683 9.70304 23.4903 9.70304C23.5746 9.70304 23.6555 9.70649 23.7339 9.71684C26.3408 10.0593 28.8102 12.8022 29.8354 14.5627C31.4994 17.4222 30.1033 19.876 29.8679 20.253L29.6963 20.4906C29.029 21.3716 26.1259 24.9963 23.5215 25.023L23.3686 25.0196L23.2677 25.0066C20.4863 24.4174 18.0321 21.8203 17.1443 20.2944C15.4811 17.4357 16.8772 15.0018 17.1134 14.6279L17.3618 14.2807Z"
                  fill="white"
                />
                <path
                  d="M53.5389 19.2869L50.5949 22.2769V26.4399H48.2949V10.3399H50.5949V19.3329L59.3349 10.3399H61.9569L55.0799 17.5849L62.3939 26.4399H59.7029L53.5389 19.2869ZM75.8118 14.2499V26.4399H73.7188V24.5999C73.2742 25.2286 72.6838 25.7193 71.9478 26.0719C71.2272 26.4093 70.4375 26.5779 69.5788 26.5779C67.9535 26.5779 66.6732 26.1333 65.7378 25.2439C64.8025 24.3393 64.3348 23.0129 64.3348 21.2649V14.2499H66.5428V21.0119C66.5428 22.1926 66.8265 23.0896 67.3938 23.7029C67.9612 24.3009 68.7738 24.5999 69.8318 24.5999C70.9972 24.5999 71.9172 24.2473 72.5918 23.5419C73.2665 22.8366 73.6038 21.8399 73.6038 20.5519V14.2499H75.8118ZM80.3653 14.2499H82.5733V26.4399H80.3653V14.2499ZM81.4693 11.9039C81.0399 11.9039 80.6796 11.7659 80.3883 11.4899C80.1123 11.2139 79.9743 10.8766 79.9743 10.4779C79.9743 10.0793 80.1123 9.74194 80.3883 9.46594C80.6796 9.17461 81.0399 9.02894 81.4693 9.02894C81.8986 9.02894 82.2513 9.16694 82.5273 9.44294C82.8186 9.70361 82.9643 10.0333 82.9643 10.4319C82.9643 10.8459 82.8186 11.1986 82.5273 11.4899C82.2513 11.7659 81.8986 11.9039 81.4693 11.9039ZM91.8771 20.7589L89.3471 23.1049V26.4399H87.1391V9.37394H89.3471V20.3219L95.9941 14.2499H98.6621L93.5331 19.2869L99.1681 26.4399H96.4541L91.8771 20.7589ZM105.876 14.1349C107.563 14.1349 108.851 14.5489 109.74 15.3769C110.645 16.2049 111.097 17.4393 111.097 19.0799V26.4399H109.004V24.8299C108.636 25.3973 108.107 25.8343 107.417 26.1409C106.743 26.4323 105.938 26.5779 105.002 26.5779C103.638 26.5779 102.541 26.2483 101.713 25.5889C100.901 24.9296 100.494 24.0633 100.494 22.9899C100.494 21.9166 100.885 21.0579 101.667 20.4139C102.449 19.7546 103.691 19.4249 105.393 19.4249H108.889V18.9879C108.889 18.0373 108.613 17.3089 108.061 16.8029C107.509 16.2969 106.697 16.0439 105.623 16.0439C104.903 16.0439 104.197 16.1666 103.507 16.4119C102.817 16.6419 102.235 16.9563 101.759 17.3549L100.839 15.6989C101.468 15.1929 102.219 14.8096 103.093 14.5489C103.967 14.2729 104.895 14.1349 105.876 14.1349ZM105.37 24.8759C106.214 24.8759 106.942 24.6919 107.555 24.3239C108.169 23.9406 108.613 23.4039 108.889 22.7139V21.0119H105.485C103.615 21.0119 102.679 21.6406 102.679 22.8979C102.679 23.5113 102.917 23.9943 103.392 24.3469C103.868 24.6996 104.527 24.8759 105.37 24.8759Z"
                  fill="#081F36"
                />
              </svg>
            </div>
            <div className="registration-left-panel__item">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.167 4.66663H13.417V6.99996H22.167V4.66663Z" fill="#3F51B5" />
                <path
                  d="M9.91634 9.91667C12.1715 9.91667 13.9997 8.0885 13.9997 5.83333C13.9997 3.57817 12.1715 1.75 9.91634 1.75C7.66118 1.75 5.83301 3.57817 5.83301 5.83333C5.83301 8.0885 7.66118 9.91667 9.91634 9.91667Z"
                  fill="#2196F3"
                />
                <path
                  d="M18.6665 14.5023V13.9189H11.6665L11.6572 5.75228C11.6572 5.10769 11.0167 4.00928 9.85004 4.00928C8.68338 4.00928 8.16654 5.16894 8.16654 5.75228C8.16654 6.33561 8.16654 19.7476 8.16654 19.7476L5.61446 17.4026C4.80304 16.5889 3.47479 16.6892 2.79113 17.5076C2.07129 18.3214 2.25096 19.5837 2.97371 20.3012L6.29346 23.6233C8.10938 25.585 10.8277 26.1684 12.6255 26.1684H16.6383C19.6121 26.1684 22.1665 23.8006 22.1665 20.8297C22.1665 20.8297 22.1665 18.011 22.1665 14.5017H18.6665V14.5023Z"
                  fill="#FFCC80"
                />
                <path
                  d="M11.667 18.0524C11.667 18.9887 12.4557 19.7523 13.417 19.7523C14.3783 19.7523 15.167 18.9864 15.167 18.0524V13.8688C15.167 12.9325 14.3783 12.1689 13.417 12.1689C12.4557 12.1689 11.667 12.9325 11.667 13.8688V18.0524ZM15.167 18.0524C15.167 18.9887 15.9557 19.7523 16.917 19.7523C17.8783 19.7523 18.667 18.9864 18.667 18.0524V13.8688C18.667 12.9325 17.8783 12.1689 16.917 12.1689C15.9557 12.1689 15.167 12.9325 15.167 13.8688V18.0524ZM18.667 18.0478C18.667 18.9823 19.4557 19.7476 20.417 19.7476C21.3783 19.7476 22.167 18.9817 22.167 18.0478V14.4521C22.167 13.5159 21.3783 12.7523 20.417 12.7523C19.4557 12.7523 18.667 13.5159 18.667 14.4521V18.0478Z"
                  fill="#FFCC80"
                />
                <path
                  d="M8.69327 5.81642C8.70027 5.13275 9.22644 4.58617 9.87336 4.59259C10.5162 4.59959 11.033 5.16017 11.0266 5.8415C11.0196 6.52692 8.68627 6.4995 8.69327 5.81642ZM3.44094 19.8048C2.90077 19.3218 2.85527 18.4899 3.33827 17.9474C3.8236 17.4096 4.65544 17.3641 5.19327 17.8494C5.73285 18.3353 3.98052 20.2901 3.44094 19.8048Z"
                  fill="#FFEBEE"
                />
                <path d="M25.667 5.83337L22.167 2.33337V9.33337L25.667 5.83337Z" fill="#3F51B5" />
              </svg>
              <div className="item__texts">
                <h3 className="item__title">Drag-and-drop elements</h3>
                <span className="item__desc">Prepare quick screen designs by drag-and-drop ready-to-use elements.</span>
              </div>
            </div>
            <div className="registration-left-panel__item">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M22.0003 14.6667H15.7337L20.0003 3.33337H12.667L8.66699 17.3334H14.4003L11.3337 30L22.0003 14.6667Z"
                  fill="#FFC107"
                />
              </svg>

              <div className="item__texts">
                <h3 className="item__title">Add actions</h3>
                <span className="item__desc">Determine how elements should behave on the application.</span>
              </div>
            </div>
            <div className="registration-left-panel__item">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M22.75 16.9166H5.25C5.25 16.9166 5.25 21.9665 5.25 22.1666C5.25 23.7772 9.16767 25.0833 14 25.0833C18.8323 25.0833 22.75 23.7772 22.75 22.1666C22.75 21.9665 22.75 16.9166 22.75 16.9166Z"
                  fill="url(#paint0_linear_2452_15677)"
                />
                <path
                  d="M22.75 11.0834H5.25C5.25 11.0834 5.25 16.7166 5.25 16.9167C5.25 18.5273 9.16767 19.8334 14 19.8334C18.8323 19.8334 22.75 18.5273 22.75 16.9167C22.75 16.7166 22.75 11.0834 22.75 11.0834Z"
                  fill="url(#paint1_linear_2452_15677)"
                />
                <path
                  d="M22.75 5.54163H5.25C5.25 5.54163 5.25 10.8832 5.25 11.0833C5.25 12.6939 9.16767 14 14 14C18.8323 14 22.75 12.6939 22.75 11.0833C22.75 10.8832 22.75 5.54163 22.75 5.54163Z"
                  fill="url(#paint2_linear_2452_15677)"
                />
                <path
                  d="M14 8.16663C18.8325 8.16663 22.75 6.99137 22.75 5.54163C22.75 4.09188 18.8325 2.91663 14 2.91663C9.16751 2.91663 5.25 4.09188 5.25 5.54163C5.25 6.99137 9.16751 8.16663 14 8.16663Z"
                  fill="url(#paint3_linear_2452_15677)"
                />
                <path
                  d="M27.8334 20.794C27.1375 20.8821 26.4247 20.5566 26.0519 19.9109C25.6792 19.2657 25.7533 18.4852 26.1779 17.9269C25.5193 17.3016 24.7167 16.8279 23.8224 16.5631C23.5518 17.2112 22.9124 17.6674 22.1663 17.6674C21.4203 17.6674 20.7809 17.2118 20.5103 16.5631C19.616 16.8274 18.8133 17.3016 18.1548 17.9269C18.5788 18.4852 18.6529 19.2657 18.2808 19.9109C17.908 20.556 17.1952 20.8821 16.4993 20.794C16.3943 21.2309 16.333 21.6854 16.333 22.1544C16.333 22.6239 16.3943 23.0778 16.4993 23.5147C17.1952 23.4266 17.908 23.7521 18.2808 24.3979C18.6535 25.043 18.5794 25.8235 18.1548 26.3818C18.8133 27.0071 19.616 27.4808 20.5103 27.7456C20.7809 27.0975 21.4203 26.6414 22.1663 26.6414C22.9124 26.6414 23.5518 27.0969 23.8224 27.7456C24.7167 27.4814 25.5193 27.0071 26.1779 26.3818C25.7538 25.8235 25.6798 25.043 26.0519 24.3979C26.4247 23.7527 27.1375 23.4266 27.8334 23.5147C27.9384 23.0778 27.9997 22.6239 27.9997 22.1544C27.9997 21.6854 27.9384 21.2309 27.8334 20.794Z"
                  fill="url(#paint4_linear_2452_15677)"
                />
                <path
                  d="M22.1666 25.2957C23.9015 25.2957 25.3079 23.8893 25.3079 22.1544C25.3079 20.4196 23.9015 19.0132 22.1666 19.0132C20.4318 19.0132 19.0254 20.4196 19.0254 22.1544C19.0254 23.8893 20.4318 25.2957 22.1666 25.2957Z"
                  fill="url(#paint5_linear_2452_15677)"
                />
                <path
                  d="M22.167 24.0666C23.2231 24.0666 24.0792 23.2105 24.0792 22.1545C24.0792 21.0984 23.2231 20.2423 22.167 20.2423C21.111 20.2423 20.2549 21.0984 20.2549 22.1545C20.2549 23.2105 21.111 24.0666 22.167 24.0666Z"
                  fill="url(#paint6_linear_2452_15677)"
                />
                <path
                  d="M27.8334 20.818C27.1375 20.906 26.4247 20.5805 26.0519 19.9348C25.6792 19.2896 25.7533 18.5091 26.1779 17.9509C25.5193 17.3255 24.7167 16.8519 23.8224 16.587C23.5518 17.2351 22.9124 17.6913 22.1663 17.6913C21.4203 17.6913 20.7809 17.2357 20.5103 16.587C19.616 16.8513 18.8133 17.3255 18.1548 17.9509C18.5788 18.5091 18.6529 19.2896 18.2808 19.9348C17.908 20.58 17.1952 20.906 16.4993 20.818C16.3943 21.2555 16.333 21.7093 16.333 22.1789C16.333 22.6485 16.3943 23.1023 16.4993 23.5392C17.1952 23.4511 17.908 23.7766 18.2808 24.4224C18.6535 25.0675 18.5794 25.848 18.1548 26.4063C18.8133 27.0316 19.616 27.5053 20.5103 27.7701C20.7809 27.122 21.4203 26.6659 22.1663 26.6659C22.9124 26.6659 23.5518 27.1215 23.8224 27.7701C24.7167 27.5059 25.5193 27.0316 26.1779 26.4063C25.7538 25.848 25.6798 25.0675 26.0519 24.4224C26.4247 23.7772 27.1375 23.4511 27.8334 23.5392C27.9384 23.1023 27.9997 22.6479 27.9997 22.1789C27.9997 21.7093 27.9384 21.2555 27.8334 20.818Z"
                  fill="url(#paint7_linear_2452_15677)"
                />
                <path
                  d="M22.1667 25.0955C23.7775 25.0955 25.0833 23.7897 25.0833 22.1789C25.0833 20.568 23.7775 19.2622 22.1667 19.2622C20.5558 19.2622 19.25 20.568 19.25 22.1789C19.25 23.7897 20.5558 25.0955 22.1667 25.0955Z"
                  fill="url(#paint8_linear_2452_15677)"
                />
                <path
                  d="M22.167 23.929C23.1335 23.929 23.917 23.1455 23.917 22.179C23.917 21.2125 23.1335 20.429 22.167 20.429C21.2005 20.429 20.417 21.2125 20.417 22.179C20.417 23.1455 21.2005 23.929 22.167 23.929Z"
                  fill="url(#paint9_linear_2452_15677)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_2452_15677"
                    x1="5.25"
                    y1="21"
                    x2="22.75"
                    y2="21"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#11408A" />
                    <stop offset="1" stopColor="#103F8F" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_2452_15677"
                    x1="5.25"
                    y1="15.4584"
                    x2="22.75"
                    y2="15.4584"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#1D59B3" />
                    <stop offset="1" stopColor="#195BBC" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_2452_15677"
                    x1="5.25"
                    y1="9.77079"
                    x2="22.75"
                    y2="9.77079"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#3079D6" />
                    <stop offset="1" stopColor="#297CD2" />
                  </linearGradient>
                  <linearGradient
                    id="paint3_linear_2452_15677"
                    x1="5.25"
                    y1="5.54163"
                    x2="22.75"
                    y2="5.54163"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#42A3F2" />
                    <stop offset="1" stopColor="#42A4EB" />
                  </linearGradient>
                  <linearGradient
                    id="paint4_linear_2452_15677"
                    x1="18.1933"
                    y1="18.1819"
                    x2="26.4982"
                    y2="26.4868"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#889097" />
                    <stop offset="0.331" stopColor="#848C94" />
                    <stop offset="0.669" stopColor="#78828B" />
                    <stop offset="1" stopColor="#64717C" />
                  </linearGradient>
                  <linearGradient
                    id="paint5_linear_2452_15677"
                    x1="24.3547"
                    y1="24.3431"
                    x2="19.9488"
                    y2="19.9372"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="white" />
                    <stop offset="0.242" stopColor="#F2F2F2" />
                    <stop offset="1" stopColor="#CCCCCC" />
                  </linearGradient>
                  <linearGradient
                    id="paint6_linear_2452_15677"
                    x1="20.378"
                    y1="20.3654"
                    x2="23.5163"
                    y2="23.5037"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#0D61A9" />
                    <stop offset="0.363" stopColor="#0E5FA4" />
                    <stop offset="0.78" stopColor="#135796" />
                    <stop offset="1" stopColor="#16528C" />
                  </linearGradient>
                  <linearGradient
                    id="paint7_linear_2452_15677"
                    x1="18.1933"
                    y1="18.2058"
                    x2="26.4982"
                    y2="26.5107"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#889097" />
                    <stop offset="0.331" stopColor="#848C94" />
                    <stop offset="0.669" stopColor="#78828B" />
                    <stop offset="1" stopColor="#64717C" />
                  </linearGradient>
                  <linearGradient
                    id="paint8_linear_2452_15677"
                    x1="24.1984"
                    y1="24.2106"
                    x2="20.1075"
                    y2="20.1197"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="white" />
                    <stop offset="0.242" stopColor="#F2F2F2" />
                    <stop offset="1" stopColor="#CCCCCC" />
                  </linearGradient>
                  <linearGradient
                    id="paint9_linear_2452_15677"
                    x1="20.5296"
                    y1="20.5415"
                    x2="23.4019"
                    y2="23.4139"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#0D61A9" />
                    <stop offset="0.363" stopColor="#0E5FA4" />
                    <stop offset="0.78" stopColor="#135796" />
                    <stop offset="1" stopColor="#16528C" />
                  </linearGradient>
                </defs>
              </svg>

              <div className="item__texts">
                <h3 className="item__title">Connect to database</h3>
                <span className="item__desc">Use Kuika’s managed database or an existing MSSQL database.</span>
              </div>
            </div>
            <div className="registration-left-panel__item">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.33301 16.3334V4.66671C2.33301 3.38337 3.38301 2.33337 4.66634 2.33337H20.9997C22.283 2.33337 23.333 3.38337 23.333 4.66671V16.3334C23.333 17.6167 22.283 18.6667 20.9997 18.6667H4.66634C3.38301 18.6667 2.33301 17.6167 2.33301 16.3334Z"
                  fill="#546E7A"
                />
                <path
                  d="M20.9997 4.08337H4.66634C4.31634 4.08337 4.08301 4.31671 4.08301 4.66671V16.3334C4.08301 16.6834 4.31634 16.9167 4.66634 16.9167H20.9997C21.3497 16.9167 21.583 16.6834 21.583 16.3334V4.66671C21.583 4.31671 21.3497 4.08337 20.9997 4.08337Z"
                  fill="#BBDEFB"
                />
                <path
                  d="M22.167 19.25H3.50033C2.21699 19.25 1.16699 18.2 1.16699 16.9166H24.5003C24.5003 18.2 23.4503 19.25 22.167 19.25Z"
                  fill="#37474F"
                />
                <path
                  d="M14 23.3333V9.33333C14 8.05 15.05 7 16.3333 7H23.3333C24.6167 7 25.6667 8.05 25.6667 9.33333V23.3333C25.6667 24.6167 24.6167 25.6667 23.3333 25.6667H16.3333C15.05 25.6667 14 24.6167 14 23.3333Z"
                  fill="#E38939"
                />
                <path
                  d="M23.3333 8.75H16.3333C15.9833 8.75 15.75 8.98333 15.75 9.33333V22.1667C15.75 22.5167 15.9833 22.75 16.3333 22.75H23.3333C23.6833 22.75 23.9167 22.5167 23.9167 22.1667V9.33333C23.9167 8.98333 23.6833 8.75 23.3333 8.75Z"
                  fill="#FFF3E0"
                />
                <path
                  d="M19.833 23.3334C19.6009 23.3334 19.3784 23.4256 19.2143 23.5897C19.0502 23.7537 18.958 23.9763 18.958 24.2084C18.958 24.4404 19.0502 24.663 19.2143 24.8271C19.3784 24.9912 19.6009 25.0834 19.833 25.0834C20.0651 25.0834 20.2876 24.9912 20.4517 24.8271C20.6158 24.663 20.708 24.4404 20.708 24.2084C20.708 23.9763 20.6158 23.7537 20.4517 23.5897C20.2876 23.4256 20.0651 23.3334 19.833 23.3334Z"
                  fill="#A6642A"
                />
              </svg>

              <div className="item__texts">
                <h3 className="item__title">Publish mobile and web apps</h3>
                <span className="item__desc">
                  Publish apps to the web or upload apps to stores as native iOS or Android.
                </span>
              </div>
            </div>
          </div>
          <div className="registration-content">
            <span className="registration-header">Sign in to your account</span>
            <div className="registration-container">
              <Form
                name="normal_login"
                onFinish={this.onSubmit}
                onChange={() => this.setState({ loginErrorMessage: "" })}
              >
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: "Please enter your email!" }]}
                  style={{ display: "block" }}
                >
                  <Input
                    prefix={
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8.56746 12.6756C6.77892 12.6756 5.32422 11.0267 5.32422 8.99989C5.32422 6.97308 6.77892 5.32422 8.56746 5.32422C10.356 5.32422 11.8107 6.97308 11.8107 8.99989C11.8107 11.0267 10.356 12.6756 8.56746 12.6756Z"
                          stroke="#818C99"
                          strokeWidth="1.4"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.8108 5.32432V10.0811C11.8108 11.5142 12.9723 12.6757 14.4054 12.6757C15.8385 12.6757 17 11.5142 17 10.0811V9C17 4.58184 13.4182 1 9 1C4.58184 1 1 4.58184 1 9C1 13.4182 4.58184 17 9 17C9.98897 17 10.9364 16.8205 11.8108 16.4923"
                          stroke="#818C99"
                          strokeWidth="1.4"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    placeholder="Username"
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[{ required: true, message: "Please enter your password!" }]}
                  style={{ marginBottom: 0 }}
                >
                  <Input.Password
                    className="kuika_login_input"
                    prefix={
                      <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12.2432 17H2.2973C1.58076 17 1 16.4193 1 15.7027V7.48651C1 6.76997 1.58076 6.18921 2.2973 6.18921H12.2432C12.9598 6.18921 13.5405 6.76997 13.5405 7.48651V15.7027C13.5405 16.4193 12.9598 17 12.2432 17Z"
                          stroke="#818C99"
                          strokeWidth="1.4"
                          strokeMiterlimit="10"
                        />
                        <path
                          d="M4.45898 6.18919V3.81081C4.45898 2.25838 5.71736 1 7.2698 1C8.82223 1 10.0806 2.25838 10.0806 3.81081V6.18919"
                          stroke="#818C99"
                          strokeWidth="1.4"
                          strokeMiterlimit="10"
                        />
                        <path
                          d="M4.24279 12.4595C4.72045 12.4595 5.10766 12.0723 5.10766 11.5946C5.10766 11.1169 4.72045 10.7297 4.24279 10.7297C3.76514 10.7297 3.37793 11.1169 3.37793 11.5946C3.37793 12.0723 3.76514 12.4595 4.24279 12.4595Z"
                          fill="#818C99"
                        />
                        <path
                          d="M7.27014 12.4595C7.74779 12.4595 8.135 12.0723 8.135 11.5946C8.135 11.1169 7.74779 10.7297 7.27014 10.7297C6.79249 10.7297 6.40527 11.1169 6.40527 11.5946C6.40527 12.0723 6.79249 12.4595 7.27014 12.4595Z"
                          fill="#818C99"
                        />
                        <path
                          d="M10.2975 12.4595C10.7751 12.4595 11.1623 12.0723 11.1623 11.5946C11.1623 11.1169 10.7751 10.7297 10.2975 10.7297C9.81983 10.7297 9.43262 11.1169 9.43262 11.5946C9.43262 12.0723 9.81983 12.4595 10.2975 12.4595Z"
                          fill="#818C99"
                        />
                      </svg>
                    }
                    iconRender={(visible) =>
                      visible ? (
                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.99667 2.16675C8.8567 2.16675 9.69672 2.30009 10.4934 2.55343L9.67339 3.37345C9.13004 3.23678 8.56669 3.16678 7.99667 3.16678C4.77657 3.16678 1.75982 5.44018 0.983125 8.45694C0.916456 8.72695 0.643115 8.88695 0.37644 8.81695C0.106432 8.75028 -0.0535731 8.47694 0.016429 8.21026C0.916456 4.70682 4.27322 2.16675 7.99667 2.16675Z"
                            fill="#818C99"
                          />
                          <path
                            d="M15.6234 8.81694C15.5834 8.83027 15.54 8.8336 15.5 8.8336C15.2767 8.8336 15.0733 8.6836 15.0167 8.45693C14.5133 6.5002 13.0633 4.85348 11.2266 3.94012L11.9799 3.18677C13.9266 4.24013 15.4267 6.04019 15.9834 8.21025C16.0534 8.47693 15.8934 8.75027 15.6234 8.81694Z"
                            fill="#818C99"
                          />
                          <path
                            d="M9.79043 5.37685L9.06374 6.10353C9.75376 6.48021 10.2238 7.21357 10.2238 8.05693C10.2238 9.2803 9.22707 10.277 8.00037 10.277C7.16035 10.277 6.42699 9.80698 6.05031 9.11696L5.32362 9.84365C5.90364 10.707 6.887 11.277 8.00037 11.277C9.77709 11.277 11.2238 9.83031 11.2238 8.05693C11.2238 6.94356 10.6538 5.95686 9.79043 5.37685ZM6.94367 6.10353L8.20704 4.84016C8.13704 4.83683 8.07037 4.8335 8.00037 4.8335C6.22365 4.8335 4.78027 6.28021 4.78027 8.05693C4.78027 8.1236 4.78361 8.1936 4.78694 8.26027L6.05031 6.99689C6.25365 6.62022 6.56699 6.30687 6.94367 6.10353Z"
                            fill="#818C99"
                          />
                        </svg>
                      ) : (
                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M1.83301 13.3337L14.1667 1"
                            stroke="#818C99"
                            strokeWidth="1.4"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                          />
                          <path
                            d="M7.99667 2.16675C8.8567 2.16675 9.69672 2.30009 10.4934 2.55343L9.67339 3.37345C9.13004 3.23678 8.56669 3.16678 7.99667 3.16678C4.77657 3.16678 1.75982 5.44018 0.983125 8.45694C0.916456 8.72695 0.643115 8.88695 0.37644 8.81695C0.106432 8.75028 -0.0535731 8.47694 0.016429 8.21026C0.916456 4.70682 4.27322 2.16675 7.99667 2.16675Z"
                            fill="#818C99"
                          />
                          <path
                            d="M15.6234 8.81694C15.5834 8.83027 15.54 8.8336 15.5 8.8336C15.2767 8.8336 15.0733 8.6836 15.0167 8.45693C14.5133 6.5002 13.0633 4.85348 11.2266 3.94012L11.9799 3.18677C13.9266 4.24013 15.4267 6.04019 15.9834 8.21025C16.0534 8.47693 15.8934 8.75027 15.6234 8.81694Z"
                            fill="#818C99"
                          />
                          <path
                            d="M9.79043 5.37685L9.06374 6.10353C9.75376 6.48021 10.2238 7.21357 10.2238 8.05693C10.2238 9.2803 9.22707 10.277 8.00037 10.277C7.16035 10.277 6.42699 9.80698 6.05031 9.11696L5.32362 9.84365C5.90364 10.707 6.887 11.277 8.00037 11.277C9.77709 11.277 11.2238 9.83031 11.2238 8.05693C11.2238 6.94356 10.6538 5.95686 9.79043 5.37685ZM6.94367 6.10353L8.20704 4.84016C8.13704 4.83683 8.07037 4.8335 8.00037 4.8335C6.22365 4.8335 4.78027 6.28021 4.78027 8.05693C4.78027 8.1236 4.78361 8.1936 4.78694 8.26027L6.05031 6.99689C6.25365 6.62022 6.56699 6.30687 6.94367 6.10353Z"
                            fill="#818C99"
                          />
                        </svg>
                      )
                    }
                    placeholder="Password"
                  />
                </Form.Item>
                <div className="kuika_registration_error">{this.state.loginErrorMessage ?? ""}</div>
                <Form.Item style={{ display: "block" }}>
                  <Button
                    style={{ marginBottom: 12 }}
                    id="sign-in-button"
                    className="registration-button"
                    htmlType="submit"
                    size="large"
                    loading={this.state.isLoading}
                  >
                    Sign in
                  </Button>
                  <div style={{ fontWeight: 500 }} className="k_Bold-Primary-Center">
                    <span className="registration-text" onClick={() => this.goToForgotPassword()}>
                      Forgot your password?
                    </span>
                  </div>
                </Form.Item>
                <div className="registration-container__sign-up-text-wrapper">
                  <span className="k_Bold-Primary-Center" onClick={() => this.goToSignUp()}>
                    <span style={{ color: "#495766" }}>Don't have an account?</span>
                    <span style={{ fontWeight: 600 }}> Sign up</span>
                  </span>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <div className="registration-footer">
          <a
            href="https://www.kuika.com/en/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="k_Medium-Primary-Left"
          >
            Privacy
          </a>
          <a
            href="https://www.kuika.com/en/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="k_Medium-Primary-Left"
          >
            Terms
          </a>
        </div>
      </div>
    );
  }
}

const login = withHistory(Login);
export { login as Login };
